import { MenuItem, PrimeIcons } from "primeng/api";
import { AbstractMenuModule } from "../menu/abstract-menu-module";
import { ClientInfoModel, CargoFeaturesModel, AuthUserModel } from "../model";

const _menuItems = [
    {
        id: 'my-tracks',
        label: 'Мои посылки',
        icon: PrimeIcons.LIST,
        routerLink: 'my-tracks',
        visible: true
      },
]

export class ClientPanelMenu extends AbstractMenuModule {
    override checkUserRole(roleName: string): boolean {
        return roleName === 'customer';
    }
    
    override buildMenu(user?: ClientInfoModel, auth?: AuthUserModel, features?: CargoFeaturesModel): MenuItem[] {
        return this.copyMenuItems(_menuItems);
    }

}